module.exports = __webpack_public_path__ + "static/laser_xl-caeedf632b5ca3176c0631fbdd269b3b.png";